module.exports = __webpack_public_path__ + "media/images/emblems/Puplinge-coat_of_arms-5b21a48a84f69381142fcb1cdd434c0c.svg";